module.exports = __webpack_public_path__ + "img/6S.0d7fd9f2.svg";